import React from 'react'
import { Container } from 'react-bootstrap'
import styled from 'styled-components'
import { Link } from 'gatsby'

class Sitelock extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({height: window.innerHeight})
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({width: window.innerWidth})
        }
    }

    
    componentDidMount() {
        this.setState({height: window.innerHeight, width: window.innerWidth})
        window.addEventListener('resize', this.updateDimensions)
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {

        const Section = styled.section`
            position: relative;
            padding: 50px 0 100px 0;            
        `

        const Overlay = styled.div`
            width: 100%;
            display: block;
            align-items: center;
            background-color: rgba(0,0,0);
            
            @media (min-width:768px) and (max-width:1500px) {
                
            }
            @media (max-width:767px) {
                             
            }
        `
        const Heading3 = styled.h3`
            font-size: 40px;
            font-family: Poppins;
            line-height: 40px;
            color: #fff;
            font-weight: 700;
            margin-top: 50px;
            text-align: center;
            text-transform: uppercase;
            background: -webkit-linear-gradient(left, #c1eb18 , #65ff00);
            background: -o-linear-gradient(right, #c1eb18, #65ff00);
            background: -moz-linear-gradient(right, #c1eb18, #65ff00);
            background: linear-gradient(to right, #c1eb18, #65ff00); 
           -webkit-background-clip: text;
           -webkit-text-fill-color: transparent;
            @media (max-width:767px) {
                font-size: 30px;
                line-height: 40px;
            }
           @media (min-width:768px) and (max-width:1500px) {
                font-size: 40px;
            }
        `
        const Heading3a = styled.h3`
        font-size: 40px;
        line-height: 40px;
        font-family: "Montserrat", sans-serif;        
        font-weight: bold;
        text-align: center; 
        margin-top: 80px;       
        @media (min-width:768px) and (max-width:1600px) {
          font-size: 40px;
          line-height: 40px;
        }
        @media (max-width:767px) {
          font-size: 30px;
          line-height: 30px;          
        }
        ` 
        const Headinga = styled(Link)`        
        color: #c1eb18;
        transition: .5s;
          &:hover {
            color: #fff;
            text-decoration: none;
          }
        `      
        
        const Content = styled.div`
            position: relative;
            z-index: 10;
            margin-top: 100px;
        `

        const Separator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #C1EB18;
            margin-bottom: 30px;
            @media (min-width:768px) {
                margin-left: 6px;
            }
            @media (max-width:767px) {
                margin-left: 2px;
            }
        `
        const Text = styled.p`
            font-size: 20px;
            font-weight: 300;
            color: #c5c5c5;
        `
        
        return (
                <Section id="home">
                    <Overlay>
                        <Container>
                            <Content>                                
                                <Heading3>
                                ¿Qué certificado SSL es el adecuado para mí?
                                </Heading3>
                                <Separator/>
                                <Text>
                                    En el vasto paisaje de la seguridad en línea, la elección del certificado SSL adecuado es crucial para proteger
                                     tu sitio web y la confianza de tus usuarios.
                                </Text>
                                <Text>
                                Con diversas marcas y tipos disponibles, explorar las opciones puede resultar abrumador. Esta guía te guiará a través
                                 de consideraciones clave, ayudándote a identificar el SSL que mejor se adapte a tus necesidades y metas de seguridad
                                  digital. Desde certificados de validación extendida (EV), pasando por los de validación de dominio (DV) y validación
                                   de organización o empresa (OV), hasta opciones amigables con el presupuesto.
                                </Text>
                                <Text>Proteger tu presencia en línea es crucial, y los certificados SSL te ofrecen un abanico de opciones. Desde los
                                   confiables certificados SAN que aseguran varios dominios hasta los Wildcard que extienden su protección a subdominios
                                    ilimitados. ¿Un solo dominio? También cubierto. Y para aquellos que buscan flexibilidad total, los innovadores
                                     certificados Flex están diseñados para adaptarse a tus necesidades cambiantes. No comprometas la seguridad; elige
                                      el certificado que se ajuste perfectamente a tu visión digital.
                                </Text>
                                <Text>Descubre el SSL que transformará tu presencia en línea en un bastión de confianza y protección.
                                </Text>
                                <Heading3a>
                                <Headinga to="/certificados-ssl">
                                Certificados SSL
                                </Headinga>
                                </Heading3a>                                
                            </Content>
                        </Container>
                    </Overlay>                    
                </Section>
        )
    }
}
export default Sitelock